








































import { computed, defineComponent, ref } from '@vue/composition-api'

export default defineComponent({
  name: 'VWord',

  setup() {
    const letters = ref<string[]>([
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      ''
    ])
    const correctAnswer: string[] = [
      's',
      'i',
      'n',
      't',
      'j',
      'a',
      'n',
      'd',
      'e',
      'd',
      'o',
      'p',
      'e',
      'r'
    ]

    const shuffledIndexes = [12, 9, 10, 1, 5, 4, 7, 8, 13, 11, 6, 2, 0, 3]

    const isCorrect = computed(() => {
      return (
        JSON.stringify(letters.value).toUpperCase() ===
        JSON.stringify(correctAnswer).toUpperCase()
      )
    })

    const remainingLetters = computed(() => {
      let result: string[] = []

      shuffledIndexes.forEach(index => {
        if (letters.value[index] === '') {
          result.push(correctAnswer[index])
        }
      })

      return result
    })

    return {
      letters,
      correctAnswer,
      isCorrect,
      remainingLetters
    }
  }
})
